import { Autocomplete as MuiAutocomplete, styled } from '@mui/material'
import { AutocompleteProps } from './Autocomplete.types'

export const Autocomplete = styled(
  // TODO any를 대체할 수 있는 방법 있으면 적용 필요
  ({ className, ...props }: AutocompleteProps<any, any, any, any>) => {
    return <MuiAutocomplete {...props} className={className} classes={{ popper: className }} />
  },
)`
  .MuiAutocomplete-inputRoot {
    font-weight: initial;
    font-size: initial;
  }
  .MuiAutocomplete-listbox .MuiAutocomplete-option {
    min-height: 48px;
    font-weight: 400;
  }
`

export const Highlight = styled('span')`
  color: #fff;
  background: ${({ theme }) => theme.palette.primary.main};
`
